import { useQuery } from "@tanstack/react-query";
import { getToken } from "../utils/token";
import axios from "axios";

export function useGetFilterAutofillData(enabled = true) {
  return useQuery({
    queryKey: ["filterAutofill"],
    queryFn: async () => {
      const TOKEN = getToken();
      const keys = [
        "Color",
        "Fabric",
        "Hand",
        "Material",
        "Artwork",
        "Artist",
        "Effect",
        "Techniques",
        "Era",
        "Location",
        "Tag"
      ];
      const requests = keys.map((key) =>
        axios.get(
          `https://amal.platform.simplifii.com/api/v1/custom/mastertags?valid=1&type=${key}`,
          {
            headers: {
              Authorization: "Bearer " + TOKEN,
            },
          }
        )
      );
      const otherRequest = [
        axios.get(
          "https://amal.platform.simplifii.com/api/v1/cards?type=Customer",
          {
            headers: {
              Authorization: "Bearer " + TOKEN,
            },
          }
        ),
        axios.get(
          "https://amal.platform.simplifii.com/api/v1/cards?type=Employee,Customer",
          {
            headers: {
              Authorization: "Bearer " + TOKEN,
            },
          }
        ),
      ];
      let filterData = {};
      const responseArray = await axios.all(requests)
      const otherResponseArray = await axios.all(otherRequest)

      console.log(responseArray, otherResponseArray);
      responseArray.forEach((res, index) => {
        filterData = {
          ...filterData,
          [keys[index]]: res.data.response.data,
        };
      });
      filterData = {
        ...filterData,
        SharedWithCliend: otherResponseArray[0].data.response.data,
        HandedOverToClients: otherResponseArray[1].data.response.data,
      };

      return filterData;
    },
    gcTime: 1000 * 60 * 60 * 24,
    enabled: enabled,
  });
}
